import React from 'react';

import { Icon, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { ILocation } from '@rbi-ctg/frontend';
import Link, { ILinkProps } from 'components/link';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';
import { nativeMapsHref } from 'utils/native-actions';

const DirectionsLinkStyled = Link.withConfig({
  alignItems: 'center',
  flexDirection: 'row',
  isUnderlined: false,
});

type Props = Omit<ILinkProps, 'color' | 'to' | 'isInline'> & {
  activeCoordinates: ILocation | null;
  mapPosition: ILocation;
};

export const DirectionsLink = makeUclComponent(
  ({ activeCoordinates, mapPosition, style, ...rest }: Props) => {
    const directionsText = t('directions');

    return (
      <DirectionsLinkStyled
        {...rest}
        color={primitive.$bbqBrown}
        accessibilityLabel={rest.accessibilityLabel ?? directionsText}
        isInline={false}
        isExternal
        style={[styles.container, style]}
        testID={rest.testID ?? 'directions-link'}
        to={nativeMapsHref(activeCoordinates, mapPosition)}
      >
        <Typography
          color={primitive.$bbqBrown}
          fontSize={primitive.fontSizes.sm}
          style={styles.text}
        >
          {directionsText}
        </Typography>
        <Icon
          color={primitive.$bbqBrown}
          variant="openInNew"
          size="$3_5"
          testID="directions-link-icon"
          style={styles.icon}
          {...hiddenAccessibilityPlatformProps}
        />
      </DirectionsLinkStyled>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  text: {
    textDecorationLine: 'underline',
  },
  icon: {
    marginLeft: 4,
    transform: [{ translateY: 1 }],
  },
});
